import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Project } from '../../../services/project/project.service';

@Component({
  selector: 'app-card-project',
  templateUrl: './card-project.component.html',
  styleUrl: './card-project.component.scss',
  standalone: true
})
export class CardProjectComponent {
  @Input() project!: Project;

  constructor(private router: Router) { }

  navigateToProjectDetails(projectId: number): void {
    const projectName = this.formatProjectName(this.project.title);
    this.router.navigate(['/proyectos', projectName, this.project.id]);
  }

  formatProjectName(title: string): string {
    return title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  getBusinessAreaIcon(area: string): string {
    switch (area?.toLowerCase()) {
      case 'industrial y comercial':
        return 'factory';
      case 'salud':
        return 'local_hospital';
      case 'público':
      case 'publico':
        return 'account_balance';
      case 'vivienda':
        return 'home';
      default:
        return 'work_outline';
    }
  }
}
